import { Injectable } from "@angular/core";
import { DeviceCaptureActivityTypes } from "xsmodules/ticket/ticket-page.service";
import { DeviceCaptureActivity, SnapshotActivity } from "xsmodules/ticket/ticket.model";
import { Activity, ActivityTypeEnum } from "../../ticket.model";

@Injectable({
    providedIn: 'root',
})
export class ActivityService {
    /**
     * Patches the raw activity recieved from the backend to match our model
     * Have been taken from XSight ticket-page.service.ts
     *
     * @param activity
     * @returns activity
     * Note: This mutates the input
     */
    public patchActivity(activity: Activity) {
        if (typeof activity.details === 'object' && Object.keys(activity.details).includes('0')) {
            activity.details = activity.details[0];
        }
        if (this.isDeviceSnapshotActivity(activity) && typeof activity.details.data === 'string') {
            // Snapshot
            activity.details.data = JSON.parse(activity.details.data);
        } else if (this.isDeviceCaptureActivity(activity)) {
            if (!activity.details.captureType) {
                // TODO remove this cleanup, captureType is now assigned in the DB
                console.error(`Activity captureType for activity ${activity.activityId} should not be empty or null`, activity);
                if (activity.activityTypeId === ActivityTypeEnum.deviceVideo) {
                    activity.details.captureType = DeviceCaptureActivityTypes.video;
                } else if (activity.activityTypeId === ActivityTypeEnum.deviceLog) {
                    activity.details.captureType = DeviceCaptureActivityTypes.adbLogs;
                } else if (activity.activityTypeId === ActivityTypeEnum.deviceScreenshot) {
                    activity.details.captureType = DeviceCaptureActivityTypes.image;
                }
            }
        }
        return activity;
    }

    private isDeviceSnapshotActivity(activity: Activity): activity is SnapshotActivity {
        return activity.activityTypeId === ActivityTypeEnum.deviceSnapshot;
    }

    private isDeviceCaptureActivity(activity: Activity): activity is DeviceCaptureActivity {
        return (
            activity &&
            (activity.activityTypeId === ActivityTypeEnum.deviceLog ||
                activity.activityTypeId === ActivityTypeEnum.deviceVideo ||
                activity.activityTypeId === ActivityTypeEnum.deviceScreenshot)
        );
    }
}
